import { useEffect } from 'react';
import { createPortal } from 'react-dom';

const Portal: React.FC = ({ children }) => {
    const mount = document.body;
    const div = document.createElement('div');
    div.className = 'custom-portal';

    useEffect(() => {
        mount?.appendChild(div);

        return () => {
            mount?.removeChild(div);
        };
    }, [mount, div]);

    return createPortal(children, div);
};

export default Portal;
